export default "__VITE_ASSET__BeqIWRkb__"